module.exports = __webpack_public_path__ + "static/media/Don't Wake Me Up.6b922fcb.jpg";